import type { NodeViewerComponent } from '.'

export const HardBreakNodeViewer: NodeViewerComponent = () => <br />
